module.exports = __webpack_public_path__ + "static/media/google-sheroes.0fa4c2d7.png";